import {
  Avatar,
  Box,
  Chip,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import React from "react";

import CustomTextInput from "components/atoms/CustomTextInput";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

import { GET_PATIENT_RECENT_VISIT } from "utils/reactQueryKeys";
import { useParams } from "react-router-dom";
import { useCustomMutation } from "store/hooks/react-query/mutate/useMutateFunc";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";

import FromOthers from "./FromOthers";
import FromSelf from "./FromSelf";
import { formatAssesmentLog } from "./utils";
import moment from "moment";
import { useAuthCtx } from "store/contextStore/auth/AuthStore";
import CustomButton from "components/atoms/CustomButton";

function AssesmentLog({
  visitId,
  assesmentLogs,
  showCommentField = true,
  handleNext = () => {},
}) {
  const { id } = useParams();
  const authCtx = useAuthCtx();
  const chatContainerRef = React.useRef(null);
  const queryClient = useQueryClient();
  const [comment, setcomment] = React.useState("");

  const [logs, setlogs] = React.useState({ dates: [], data: {} });

  React.useEffect(() => {
    if (logs.dates.length) {
      chatContainerRef?.current?.scrollTo({
        top: chatContainerRef?.current?.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [logs]);

  React.useMemo(() => {
    if (assesmentLogs?.length) setlogs(formatAssesmentLog(assesmentLogs));
  }, [assesmentLogs]);

  //patch visit {assesmentlog}
  const { mutate, isLoading } = useCustomMutation(
    {
      url: `/visit/${visitId}`,
      method: "patch",
      data: {
        assessmentLog: [{ note: { comment } }],
      },
    },
    {
      onSuccess: () => {
        setcomment("");
        queryClient.invalidateQueries([GET_PATIENT_RECENT_VISIT, id]);
        toast.success("Success");
      },

      onError: (error) => {
        if (Array.isArray(error.message)) {
          return error.message.map((msg) => toast.error(msg));
        }

        return toast.error(error.message);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment) return;
    mutate();
  };

  return (
    <Box id={"outer_box_container"}>
      <Box
        sx={{
          width: "100%",
          minHeight: "60vh",
          maxHeight: "100vh",
          p: 1,
          mt: 2,
          overflowY: "auto",

          display: "flex",
          flexDirection: "column",
        }}
        ref={chatContainerRef}
      >
        {logs?.dates?.length ? (
          logs.dates.map((date) => (
            <React.Fragment key={date}>
              <Divider>
                <Chip
                  sx={{ fontSize: "11px" }}
                  label={moment(date).format("MMM Do, YY")}
                  variant="outlined"
                />
              </Divider>

              {logs.data[date].map((item) => (
                <React.Fragment key={item._id}>
                  {/* check if its logged in user */}
                  {item.noteBy._id === authCtx?.state?.user?._id ? (
                    <FromSelf item={item} />
                  ) : (
                    <FromOthers item={item} />
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))
        ) : (
          <Paper sx={{ p: 2 }}>
            <Typography>No data</Typography>
          </Paper>
        )}
      </Box>
      {showCommentField && (
        <form
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onSubmit={handleSubmit}
        >
          <CustomTextInput
            boxSx={{ width: "100%" }}
            value={comment}
            name="comment"
            handleChange={(e) => setcomment(e.target.value)}
            placeholder="Type a new message"
          />
          <IconButton
            sx={{ ml: 1 }}
            onClick={handleSubmit}
            disabled={isLoading}
            type="submit"
          >
            <Avatar
              sx={{
                backgroundColor: isLoading
                  ? "background.gray3"
                  : "secondary.main",
              }}
            >
              <SendOutlinedIcon
                sx={{
                  color: isLoading ? "primary.gray" : "white",
                  transform: "rotate(-30deg)",
                }}
              />
            </Avatar>
          </IconButton>
        </form>
      )}
      {showCommentField && (
        <Stack alignItems={"end"} mt={5}>
          <CustomButton
            text={"Next"}
            onClick={handleNext}
            variant="containedBrown"
            sx={{ width: "200px" }}
          />
        </Stack>
      )}
    </Box>
  );
}

export default AssesmentLog;
